import React from 'react'
import BreadCrum from '../components/BreadCrum'
import Container from '../components/Container'
import Meta from '../components/Meta'

const RefundPolicy = () => {
  return (
    <>
        <Meta title='Refund Policy'/>
        <BreadCrum title='Refund Policy' />
        <Container class1="policy-wrapper py-3 home-wrapper-2">
          <div className="row">
            <div className="col-12">
              <div className="policy">
                
              </div>
            </div>
          </div>
        </Container>
    </>
  )
}

export default RefundPolicy